import { FormKitNode } from "@formkit/core";

/**
 * (Auto) Enable clear search on open for autocomplete inputs.
 */
export default function enableClearSearchOnOpen(node: FormKitNode): void {
  if (node.props.type === "autocomplete") {
    node.props.clearSearchOnOpen = true;
  }
}
